/* Restock Meter.

   Two things worth not "tidying" later:
     · The observer watches the TRACK, never the fill. An empty fill has zero
       area, so a threshold-based observer would never see it arrive and the
       bar would sit at nothing for good.
     · The markup ships the finished width. This zeroes it before animating,
       so with JS off or broken the bar still states its figure rather than
       reading as sold-out-zero-percent. */

(function () {
  function initRestock(root) {
    (root || document).querySelectorAll('[data-restock]').forEach(function (track) {
      if (track.dataset.restockReady) return;
      track.dataset.restockReady = '1';

      var fill   = track.querySelector('[data-restock-fill]');
      var value  = track.querySelector('[data-restock-value]');
      var target = parseFloat(track.getAttribute('data-restock'));
      var dur    = parseFloat(track.getAttribute('data-restock-duration')) || 1600;
      var thresh = parseFloat(track.getAttribute('data-restock-threshold'));
      if (!fill || isNaN(target)) return;
      if (isNaN(thresh)) thresh = 0.4;

      function settle() {
        fill.style.width = target + '%';
        if (value) value.textContent = String(Math.round(target));
      }

      /* Reduced motion, or no observer to hang it on: just state the figure. */
      var still = window.matchMedia &&
        window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (still || !('IntersectionObserver' in window)) { settle(); return; }

      fill.style.width = '0%';
      if (value) value.textContent = '0';

      function run() {
        var start = null;
        function frame(now) {
          if (start === null) start = now;
          var t = Math.min(1, (now - start) / dur);
          var eased = 1 - Math.pow(1 - t, 3); /* ease-out cubic */
          fill.style.width = (target * eased) + '%';
          if (value) value.textContent = String(Math.round(target * eased));
          if (t < 1) requestAnimationFrame(frame);
          else settle();
        }
        requestAnimationFrame(frame);
      }

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          io.disconnect();
          run();
        });
      }, { threshold: thresh });

      io.observe(track);
    });
  }

  window.initRestock = initRestock;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initRestock(); });
  } else {
    initRestock();
  }

  /* The theme editor swaps markup in without a reload. */
  document.addEventListener('shopify:section:load', function (event) {
    initRestock(event.target);
  });
  document.addEventListener('shopify:block:select', function (event) {
    initRestock(event.target);
  });
})();
